import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
    cancelBooking,
    checkOutBooking,
    checkInBooking,
    updateBookingTimes,
    clickEditBookingTime,
} from '../actions/bookings';

import {
    trackEditBookingTimeClick,
} from '../actions/analytics';

import Booking from '../components/Booking/Booking';

class BookingContainer extends Component {
    render() {
        return (
            <Booking { ...this.props } />
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { bookings, plant, currentAvailabilityWindows } = state.entities;
    const booking = bookings[ownProps.params.staticUId];
    const availabilityWindow = currentAvailabilityWindows[ownProps.params.staticUId];

    return {
        booking,
        plant,
        availabilityWindow,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        cancelBooking,
        checkOutBooking,
        checkInBooking,
        updateBookingTimes,
        clickEditBookingTime,
        trackEditBookingTimeClick,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingContainer);



// WEBPACK FOOTER //
// ./scripts/containers/BookingContainer.jsx